const H = (t, i, c = !1, r = null, f = "") => {
  const u = document.getElementById(t) ?? null;
  if (!u)
    return null;
  const S = document.createElement("iframe"), b = c ? "cvv_" : "";
  return S.src = i, S.id = `tx_iframe_${b}${r ?? t}`, S.name = `tx_iframe_${b}${r ?? t}`, S.width = "100%", S.height = "100%", S.setAttribute("frameborder", "0"), S.setAttribute("style", f), S.setAttribute("crossorigin", "anonymous"), u.appendChild(S), S;
}, Q = (t) => t.clientSecret !== void 0, x = (t) => !t || typeof t == "string" && t.trim() === "" ? !0 : typeof t == "object" ? Object.keys(t).length === 0 : !1, $ = (t) => typeof t == "string" ? x(t) : Number(t) <= 0 || !isFinite(t), ot = (t = /* @__PURE__ */ new Date()) => {
  const i = t.getUTCFullYear(), c = F(t.getUTCMonth() + 1), r = F(t.getUTCDate()), f = F(t.getUTCHours()), u = F(t.getUTCMinutes()), S = F(t.getUTCSeconds());
  return `${i}${c}${r}${f}${u}${S}`;
}, F = (t) => t < 10 ? `0${t}` : `${t}`, vt = (t) => {
  const i = /* @__PURE__ */ new Date();
  return $(t) ? i : new Date(i.getTime() + st(t));
}, st = (t) => t * 1e3, z = (t, i) => {
  const c = new URL(t), r = {};
  for (const f in i) {
    const u = i[f];
    if (!x(u)) {
      if (typeof u == "object") {
        for (const S in u) {
          const b = u[S];
          x(b) || (r[`${f}.${S}`] = b);
        }
        continue;
      }
      r[f] = i[f];
    }
  }
  return c.search = new URLSearchParams(r).toString(), c;
};
let e = {};
const gt = (t) => {
  e = t;
}, D = (t, i, c = !1) => {
  var r;
  ((r = e.additionalSettings) != null && r.debug || c) && console.log(
    `TokenEx Iframe Debug: ${JSON.stringify({ message: t, details: i })}`
  );
}, K = (t) => {
  if (x(t))
    return null;
  try {
    return JSON.parse(t);
  } catch {
    return null;
  }
}, j = (t) => {
  try {
    return new RegExp(t), !0;
  } catch {
    return !1;
  }
};
let O = {
  test: "https://test-htp.tokenex.com",
  production: "https://htp.tokenex.com",
  eu: "https://eu1-htp.tokenex.com",
  pcipro: "https://htp.pcipro.co",
  eupcipro: "https://eu1-htp.pcipro.co"
};
({}).VITE_APP_ENVIRONMENTS_LOCAL && (O = {
  ...O,
  local: {}.VITE_APP_ENVIRONMENTS_LOCAL
});
({}).VITE_APP_ENVIRONMENTS_DEV && (O = {
  ...O,
  dev: {}.VITE_APP_ENVIRONMENTS_DEV
});
({}).VITE_APP_ENVIRONMENTS_STAGING && (O = {
  ...O,
  staging: {}.VITE_APP_ENVIRONMENTS_STAGING
});
const ct = (t = !1) => {
  var r, f, u, S, b, _, h;
  const i = [];
  if (x(e.auth)) {
    i.push("Missing authentication");
    const o = i.length === 0;
    return D("Auth Config", { valid: o, details: i, config: e }, t), {
      valid: o,
      details: i
    };
  }
  if ((x(e.env) || x(O[e.env] ?? "")) && i.push("Missing or invalid environment"), x(e.auth.origin) && i.push("Missing origin property"), (e.auth.origin.split(',')[0] !== window.location.origin) && i.push(
    `Expected origin of ${window.location.origin} but current origin is ${e.auth.origin.split(',')[0]}`
  ), x(e.auth.tokenExId) && i.push("Missing tokenExId property"), ($(e.auth.tokenExId) || isNaN(Number(e.auth.tokenExId))) && i.push("Invalid tokenExId property. tokenExId value must be numeric"), $(e.auth.tokenScheme) && i.push("Missing tokenScheme property"), Q(e.auth) && x(e.auth.clientSecret) && i.push("Missing clientSecret property"), Q(e.auth) || (x(e.auth.hmac) && i.push("Missing hmac property"), x(e.auth.timestamp) && i.push("Missing timestamp property")), (!e.initialSettings.expiresInSeconds || isNaN(e.initialSettings.expiresInSeconds) || e.initialSettings.expiresInSeconds > 1200 || e.initialSettings.expiresInSeconds <= 0) && (D(
    "Invalid expiration time, setting expiresInSeconds to 1200"
  ), e.initialSettings.expiresInSeconds = 1200), e.initialSettings.use3DS) {
    e.initialSettings.pci || i.push("Missing pci property"), x(e.initialSettings.threeDSMethodNotificationUrl ?? "") && i.push("Missing threeDSMethodNotificationUrl property"), e.initialSettings.cvvOnly && i.push("Invalid property cvvOnly for use3DS configuration");
    const o = i.length === 0;
    return D("3DS Config", { valid: o, details: i, config: e }, t), {
      valid: o,
      details: i
    };
  }
  if (e.initialSettings.useKount) {
    e.initialSettings.pci || i.push("Missing pci property"), x(e.initialSettings.kountMerchantId ?? "") && i.push("Missing Kount MerchantId property"), e.initialSettings.cvvOnly && i.push("Invalid property cvvOnly for fraudServices configuration");
    const o = i.length === 0;
    return D("Kount Config", { valid: o, details: i, config: e }, t), {
      valid: o,
      details: i
    };
  }
  if (e.initialSettings.cvvOnly) {
    D("Missing pci property for cvvOnly, setting pci to true"), e.initialSettings.pci = !0, x(((r = e.additionalSettings) == null ? void 0 : r.cardType) ?? "") && i.push("Missing cardType property"), x(e.initialSettings.token ?? "") && i.push("Missing token property");
    const o = i.length === 0;
    return D("Cvv Only Config", { valid: o, details: i, config: e }, t), {
      valid: o,
      details: i
    };
  }
  if (e.initialSettings.cvv && !e.initialSettings.cvvOnly && (D("Missing pci property, setting pci to true"), e.initialSettings.pci = !0, e.initialSettings.cvvContainer || i.push("Missing cvvContainer property")), ((f = e.additionalSettings) != null && f.forterSiteId || (u = e.additionalSettings) != null && u.forterUsername) && (e.initialSettings.pci || i.push("Missing pci property"), e.additionalSettings.forterSiteId || i.push("Missing forterSiteId property"), e.additionalSettings.forterUsername || i.push("Missing forterUsername property")), e.initialSettings.pci && !e.initialSettings.cvvOnly && !x((S = e.additionalSettings) == null ? void 0 : S.customDataTypes)) {
    const o = typeof ((b = e.additionalSettings) == null ? void 0 : b.customDataTypes) == "string" ? K((_ = e.additionalSettings) == null ? void 0 : _.customDataTypes) : (h = e.additionalSettings) == null ? void 0 : h.customDataTypes;
    (o == null ? void 0 : o.every(
      (s) => s.type && !x(s.type) && !$(s.maxLength) && !x(s.validRegex) && j(s.validRegex) && !x(s.possibleRegEx) && j(s.possibleRegEx)
    )) || i.push("Invalid card custom data type"), o.some(
      (s) => !x(s.type) && s.type.toLowerCase() === "unknown"
    ) && i.push("Unknown custom data type for card type"), e.initialSettings.cvv && (o != null && o.every(
      (y) => !x(y.cvvValidRegex) && j(y.cvvValidRegex) && !$(y.cvvMaxLength)
    ) || i.push("Invalid card or cvv custom data type"));
  }
  const c = i.length === 0;
  return D("Validate Config", { valid: c, details: i, config: e }, t), {
    valid: c,
    details: i
  };
}, tt = "tx_iframe_", L = (t, i) => {
  globalThis && (globalThis == null || globalThis.addEventListener(
    `${tt}${t}`,
    (c) => {
      const r = c;
      D("Post message received from iframe", { event: t, message: r }), i(r.detail.data);
    }
  ));
}, mt = () => {
  globalThis && (D("Setting up post message listener", {}), globalThis == null || globalThis.addEventListener("message", lt));
}, St = () => {
  globalThis && (D("Removing post message listener", {}), globalThis == null || globalThis.removeEventListener("message", lt));
}, lt = (t) => {
  if (!globalThis || !t || t.origin !== O[e.env])
    return;
  const i = K(t.data);
  !i || !i.event || (D("Dispatch event from post message", i), globalThis == null || globalThis.dispatchEvent(
    new CustomEvent(`${tt}${i.event}`, {
      bubbles: !0,
      detail: { data: i.data }
    })
  ));
}, A = (t, i) => {
  var f;
  const c = {
    fromIframeV3: !0,
    command: t,
    data: i
  }, r = document.getElementById(
    M.iframeContainer.id
  );
  D("Sending post message to iframe", c), (f = r.contentWindow) == null || f.postMessage(
    JSON.stringify(c),
    M.origin
  );
};
var N = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ut(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function yt(t) {
  if (t.__esModule)
    return t;
  var i = t.default;
  if (typeof i == "function") {
    var c = function r() {
      return this instanceof r ? Reflect.construct(i, arguments, this.constructor) : i.apply(this, arguments);
    };
    c.prototype = i.prototype;
  } else
    c = {};
  return Object.defineProperty(c, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var f = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(c, r, f.get ? f : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), c;
}
var dt = { exports: {} };
function _t(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var X = { exports: {} };
const It = {}, xt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: It
}, Symbol.toStringTag, { value: "Module" })), bt = /* @__PURE__ */ yt(xt);
var nt;
function q() {
  return nt || (nt = 1, function(t, i) {
    (function(c, r) {
      t.exports = r();
    })(N, function() {
      var c = c || function(r, f) {
        var u;
        if (typeof window < "u" && window.crypto && (u = window.crypto), typeof self < "u" && self.crypto && (u = self.crypto), typeof globalThis < "u" && globalThis.crypto && (u = globalThis.crypto), !u && typeof window < "u" && window.msCrypto && (u = window.msCrypto), !u && typeof N < "u" && N.crypto && (u = N.crypto), !u && typeof _t == "function")
          try {
            u = bt;
          } catch {
          }
        var S = function() {
          if (u) {
            if (typeof u.getRandomValues == "function")
              try {
                return u.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof u.randomBytes == "function")
              try {
                return u.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, b = Object.create || function() {
          function n() {
          }
          return function(a) {
            var d;
            return n.prototype = a, d = new n(), n.prototype = null, d;
          };
        }(), _ = {}, h = _.lib = {}, o = h.Base = function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(n) {
              var a = b(this);
              return n && a.mixIn(n), (!a.hasOwnProperty("init") || this.init === a.init) && (a.init = function() {
                a.$super.init.apply(this, arguments);
              }), a.init.prototype = a, a.$super = this, a;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var n = this.extend();
              return n.init.apply(n, arguments), n;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(n) {
              for (var a in n)
                n.hasOwnProperty(a) && (this[a] = n[a]);
              n.hasOwnProperty("toString") && (this.toString = n.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), p = h.WordArray = o.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(n, a) {
            n = this.words = n || [], a != f ? this.sigBytes = a : this.sigBytes = n.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(n) {
            return (n || s).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(n) {
            var a = this.words, d = n.words, g = this.sigBytes, T = n.sigBytes;
            if (this.clamp(), g % 4)
              for (var C = 0; C < T; C++) {
                var w = d[C >>> 2] >>> 24 - C % 4 * 8 & 255;
                a[g + C >>> 2] |= w << 24 - (g + C) % 4 * 8;
              }
            else
              for (var E = 0; E < T; E += 4)
                a[g + E >>> 2] = d[E >>> 2];
            return this.sigBytes += T, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var n = this.words, a = this.sigBytes;
            n[a >>> 2] &= 4294967295 << 32 - a % 4 * 8, n.length = r.ceil(a / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var n = o.clone.call(this);
            return n.words = this.words.slice(0), n;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(n) {
            for (var a = [], d = 0; d < n; d += 4)
              a.push(S());
            return new p.init(a, n);
          }
        }), m = _.enc = {}, s = m.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(n) {
            for (var a = n.words, d = n.sigBytes, g = [], T = 0; T < d; T++) {
              var C = a[T >>> 2] >>> 24 - T % 4 * 8 & 255;
              g.push((C >>> 4).toString(16)), g.push((C & 15).toString(16));
            }
            return g.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(n) {
            for (var a = n.length, d = [], g = 0; g < a; g += 2)
              d[g >>> 3] |= parseInt(n.substr(g, 2), 16) << 24 - g % 8 * 4;
            return new p.init(d, a / 2);
          }
        }, y = m.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(n) {
            for (var a = n.words, d = n.sigBytes, g = [], T = 0; T < d; T++) {
              var C = a[T >>> 2] >>> 24 - T % 4 * 8 & 255;
              g.push(String.fromCharCode(C));
            }
            return g.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(n) {
            for (var a = n.length, d = [], g = 0; g < a; g++)
              d[g >>> 2] |= (n.charCodeAt(g) & 255) << 24 - g % 4 * 8;
            return new p.init(d, a);
          }
        }, l = m.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(n) {
            try {
              return decodeURIComponent(escape(y.stringify(n)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(n) {
            return y.parse(unescape(encodeURIComponent(n)));
          }
        }, v = h.BufferedBlockAlgorithm = o.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new p.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(n) {
            typeof n == "string" && (n = l.parse(n)), this._data.concat(n), this._nDataBytes += n.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(n) {
            var a, d = this._data, g = d.words, T = d.sigBytes, C = this.blockSize, w = C * 4, E = T / w;
            n ? E = r.ceil(E) : E = r.max((E | 0) - this._minBufferSize, 0);
            var k = E * C, B = r.min(k * 4, T);
            if (k) {
              for (var P = 0; P < k; P += C)
                this._doProcessBlock(g, P);
              a = g.splice(0, k), d.sigBytes -= B;
            }
            return new p.init(a, B);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var n = o.clone.call(this);
            return n._data = this._data.clone(), n;
          },
          _minBufferSize: 0
        });
        h.Hasher = v.extend({
          /**
           * Configuration options.
           */
          cfg: o.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(n) {
            this.cfg = this.cfg.extend(n), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            v.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(n) {
            return this._append(n), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(n) {
            n && this._append(n);
            var a = this._doFinalize();
            return a;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(n) {
            return function(a, d) {
              return new n.init(d).finalize(a);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(n) {
            return function(a, d) {
              return new I.HMAC.init(n, d).finalize(a);
            };
          }
        });
        var I = _.algo = {};
        return _;
      }(Math);
      return c;
    });
  }(X)), X.exports;
}
var G = { exports: {} }, it;
function Tt() {
  return it || (it = 1, function(t, i) {
    (function(c, r) {
      t.exports = r(q());
    })(N, function(c) {
      return function(r) {
        var f = c, u = f.lib, S = u.WordArray, b = u.Hasher, _ = f.algo, h = [], o = [];
        (function() {
          function s(I) {
            for (var n = r.sqrt(I), a = 2; a <= n; a++)
              if (!(I % a))
                return !1;
            return !0;
          }
          function y(I) {
            return (I - (I | 0)) * 4294967296 | 0;
          }
          for (var l = 2, v = 0; v < 64; )
            s(l) && (v < 8 && (h[v] = y(r.pow(l, 1 / 2))), o[v] = y(r.pow(l, 1 / 3)), v++), l++;
        })();
        var p = [], m = _.SHA256 = b.extend({
          _doReset: function() {
            this._hash = new S.init(h.slice(0));
          },
          _doProcessBlock: function(s, y) {
            for (var l = this._hash.words, v = l[0], I = l[1], n = l[2], a = l[3], d = l[4], g = l[5], T = l[6], C = l[7], w = 0; w < 64; w++) {
              if (w < 16)
                p[w] = s[y + w] | 0;
              else {
                var E = p[w - 15], k = (E << 25 | E >>> 7) ^ (E << 14 | E >>> 18) ^ E >>> 3, B = p[w - 2], P = (B << 15 | B >>> 17) ^ (B << 13 | B >>> 19) ^ B >>> 10;
                p[w] = k + p[w - 7] + P + p[w - 16];
              }
              var V = d & g ^ ~d & T, R = v & I ^ v & n ^ I & n, W = (v << 30 | v >>> 2) ^ (v << 19 | v >>> 13) ^ (v << 10 | v >>> 22), pt = (d << 26 | d >>> 6) ^ (d << 21 | d >>> 11) ^ (d << 7 | d >>> 25), et = C + pt + V + o[w] + p[w], ht = W + R;
              C = T, T = g, g = d, d = a + et | 0, a = n, n = I, I = v, v = et + ht | 0;
            }
            l[0] = l[0] + v | 0, l[1] = l[1] + I | 0, l[2] = l[2] + n | 0, l[3] = l[3] + a | 0, l[4] = l[4] + d | 0, l[5] = l[5] + g | 0, l[6] = l[6] + T | 0, l[7] = l[7] + C | 0;
          },
          _doFinalize: function() {
            var s = this._data, y = s.words, l = this._nDataBytes * 8, v = s.sigBytes * 8;
            return y[v >>> 5] |= 128 << 24 - v % 32, y[(v + 64 >>> 9 << 4) + 14] = r.floor(l / 4294967296), y[(v + 64 >>> 9 << 4) + 15] = l, s.sigBytes = y.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var s = b.clone.call(this);
            return s._hash = this._hash.clone(), s;
          }
        });
        f.SHA256 = b._createHelper(m), f.HmacSHA256 = b._createHmacHelper(m);
      }(Math), c.SHA256;
    });
  }(G)), G.exports;
}
var J = { exports: {} }, rt;
function Ct() {
  return rt || (rt = 1, function(t, i) {
    (function(c, r) {
      t.exports = r(q());
    })(N, function(c) {
      (function() {
        var r = c, f = r.lib, u = f.Base, S = r.enc, b = S.Utf8, _ = r.algo;
        _.HMAC = u.extend({
          /**
           * Initializes a newly created HMAC.
           *
           * @param {Hasher} hasher The hash algorithm to use.
           * @param {WordArray|string} key The secret key.
           *
           * @example
           *
           *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
           */
          init: function(h, o) {
            h = this._hasher = new h.init(), typeof o == "string" && (o = b.parse(o));
            var p = h.blockSize, m = p * 4;
            o.sigBytes > m && (o = h.finalize(o)), o.clamp();
            for (var s = this._oKey = o.clone(), y = this._iKey = o.clone(), l = s.words, v = y.words, I = 0; I < p; I++)
              l[I] ^= 1549556828, v[I] ^= 909522486;
            s.sigBytes = y.sigBytes = m, this.reset();
          },
          /**
           * Resets this HMAC to its initial state.
           *
           * @example
           *
           *     hmacHasher.reset();
           */
          reset: function() {
            var h = this._hasher;
            h.reset(), h.update(this._iKey);
          },
          /**
           * Updates this HMAC with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {HMAC} This HMAC instance.
           *
           * @example
           *
           *     hmacHasher.update('message');
           *     hmacHasher.update(wordArray);
           */
          update: function(h) {
            return this._hasher.update(h), this;
          },
          /**
           * Finalizes the HMAC computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The HMAC.
           *
           * @example
           *
           *     var hmac = hmacHasher.finalize();
           *     var hmac = hmacHasher.finalize('message');
           *     var hmac = hmacHasher.finalize(wordArray);
           */
          finalize: function(h) {
            var o = this._hasher, p = o.finalize(h);
            o.reset();
            var m = o.finalize(this._oKey.clone().concat(p));
            return m;
          }
        });
      })();
    });
  }(J)), J.exports;
}
(function(t, i) {
  (function(c, r, f) {
    t.exports = r(q(), Tt(), Ct());
  })(N, function(c) {
    return c.HmacSHA256;
  });
})(dt);
var wt = dt.exports;
const Et = /* @__PURE__ */ ut(wt);
var ft = { exports: {} };
(function(t, i) {
  (function(c, r) {
    t.exports = r(q());
  })(N, function(c) {
    return function() {
      var r = c, f = r.lib, u = f.WordArray, S = r.enc;
      S.Base64 = {
        /**
         * Converts a word array to a Base64 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The Base64 string.
         *
         * @static
         *
         * @example
         *
         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
         */
        stringify: function(_) {
          var h = _.words, o = _.sigBytes, p = this._map;
          _.clamp();
          for (var m = [], s = 0; s < o; s += 3)
            for (var y = h[s >>> 2] >>> 24 - s % 4 * 8 & 255, l = h[s + 1 >>> 2] >>> 24 - (s + 1) % 4 * 8 & 255, v = h[s + 2 >>> 2] >>> 24 - (s + 2) % 4 * 8 & 255, I = y << 16 | l << 8 | v, n = 0; n < 4 && s + n * 0.75 < o; n++)
              m.push(p.charAt(I >>> 6 * (3 - n) & 63));
          var a = p.charAt(64);
          if (a)
            for (; m.length % 4; )
              m.push(a);
          return m.join("");
        },
        /**
         * Converts a Base64 string to a word array.
         *
         * @param {string} base64Str The Base64 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
         */
        parse: function(_) {
          var h = _.length, o = this._map, p = this._reverseMap;
          if (!p) {
            p = this._reverseMap = [];
            for (var m = 0; m < o.length; m++)
              p[o.charCodeAt(m)] = m;
          }
          var s = o.charAt(64);
          if (s) {
            var y = _.indexOf(s);
            y !== -1 && (h = y);
          }
          return b(_, h, p);
        },
        _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
      };
      function b(_, h, o) {
        for (var p = [], m = 0, s = 0; s < h; s++)
          if (s % 4) {
            var y = o[_.charCodeAt(s - 1)] << s % 4 * 2, l = o[_.charCodeAt(s)] >>> 6 - s % 4 * 2, v = y | l;
            p[m >>> 2] |= v << 24 - m % 4 * 8, m++;
          }
        return u.create(p, m);
      }
    }(), c.enc.Base64;
  });
})(ft);
var Dt = ft.exports;
const Mt = /* @__PURE__ */ ut(Dt);
let M = {};
const At = () => {
  var v;
  const { valid: t, details: i } = ct();
  if (!t) {
    D("Invalid Config Object", i, !0);
    return;
  }
  mt();
  const { auth: c, env: r, initialSettings: f } = e, { tokenExId: u, origin: S, tokenScheme: b } = c, _ = O[r] ?? "", h = `${_}/iframe/v3`;
  let o, p;
  Q(c) ? (p = ot(), o = Mt.stringify(
    Et(
      `${u}|${S}|${p}|${f != null && f.cvvOnly ? f.token : b}`,
      c.clientSecret
    )
  )) : (o = c.hmac, p = c.timestamp);
  const m = o, s = {
    origin: S,
    tokenExId: u,
    tokenScheme: b,
    timestamp: p,
    authenticationKey: m,
    iframeVersion: "3.67.1-beta.6",
    ...f
  }, y = z(h, {
    ...s,
    mode: "Data"
  }).toString(), l = H(
    s.container,
    y
  );
  if (l) {
    const I = vt(
      ((v = e.initialSettings) == null ? void 0 : v.expiresInSeconds) ?? 1200
    );
    Z({
      authenticationKey: m,
      iframeContainer: l,
      timestamp: p,
      expirationTimeStamp: I,
      origin: _,
      configuration: e
    });
  }
  if (!s.cvvOnly && s.cvv && s.cvvContainer) {
    const I = z(h, {
      ...s,
      mode: "Cvv"
    }).toString(), n = H(
      s.cvvContainer,
      I,
      !0
    );
    n && Z({ ...M, cvvIframeContainer: n });
  }
}, Z = (t) => {
  M = t, D("Iframe Loaded", M);
}, Bt = () => {
  var c, r;
  const t = M.iframeContainer;
  t && ((c = t.parentNode) == null || c.removeChild(t));
  const i = M.cvvIframeContainer;
  i && ((r = i.parentNode) == null || r.removeChild(i)), St(), Z({});
}, kt = (t, i, c, r) => {
  if (x(t))
    return D("Device fingerprinting not supported for this PAN", {
      message: "Send 'MethodCompletionIndicator':'3' or 'MethodCompletionIndicator':'ResultUnavailable' within the ThreeDSecure Authentications request."
    }), null;
  const f = {
    AuthenticationKey: M.authenticationKey,
    Origin: e.auth.origin,
    TokenExID: e.auth.tokenExId,
    TokenScheme: e.auth.tokenScheme,
    PCI: !0,
    Timestamp: M.timestamp,
    CustomerRefNumber: r,
    ThreeDSMethodUrl: t,
    ThreeDSServerTransID: i,
    ThreeDSMethodNotificationUrl: c
  }, u = z(
    `${M.origin}/iframe/v3/DeviceFingerprint`,
    f
  ).toString();
  return H(
    e.initialSettings.container,
    u,
    !1,
    "deviceFingerprint",
    "display: none"
  );
}, Ot = () => {
  const t = {
    AuthenticationKey: M.authenticationKey,
    Origin: e.auth.origin,
    TokenExID: e.auth.tokenExId,
    TokenScheme: e.auth.tokenScheme,
    Timestamp: M.timestamp,
    MerchantId: e.initialSettings.kountMerchantId
  }, i = z(
    `${M.origin}/iframe/v3/KountDataCollection`,
    t
  ).toString();
  return H(
    e.initialSettings.container,
    i,
    !1,
    "kount_deviceDataCollector",
    "display: none"
  );
}, Pt = (t) => K(t) ? (A("setFraudServicesRiskRequestModel", t), {
  success: !0,
  details: "Fraud Services risk request details have been received successfully."
}) : {
  success: !1,
  details: "Error while parsing data, please verify and retry."
}, Y = 60;
let at;
const U = (t) => {
  globalThis == null || globalThis.dispatchEvent(
    new CustomEvent(`${tt}notice`, {
      bubbles: !0,
      detail: { data: t }
    })
  );
}, Rt = () => {
  clearTimeout(at);
  const t = ot(
    M.expirationTimeStamp
  );
  U({ type: "ExpirationWarning", expirationTimeStamp: t }), M.expirationTimeStamp.getSeconds() - (/* @__PURE__ */ new Date()).getSeconds() <= Y || (at = setTimeout(
    () => {
      U({
        type: "ExpirationWarning",
        secondsRemaining: Y
      });
    },
    st(
      M.expirationTimeStamp.getSeconds() - Y
    )
  ));
}, Nt = () => {
  L("load", () => {
    var i, c, r, f, u, S, b, _, h, o, p, m, s, y, l, v, I, n, a, d, g, T, C, w, E, k, B, P, V;
    Rt();
    const t = [
      {
        command: "setType",
        data: (i = e.additionalSettings) != null && i.maskInput ? "password" : ((c = e.additionalSettings) == null ? void 0 : c.inputType) ?? "text"
      }
    ];
    if ((r = e.additionalSettings) != null && r.styles && t.push({
      command: "setStyle",
      data: (f = e.additionalSettings) == null ? void 0 : f.styles
    }), (u = e.additionalSettings) != null && u.placeholder && t.push({
      command: "setPlaceholder",
      data: (S = e.additionalSettings) == null ? void 0 : S.placeholder
    }), e.initialSettings.pci) {
      if (!x((b = e.additionalSettings) == null ? void 0 : b.customDataTypes)) {
        let R = (_ = e.additionalSettings) == null ? void 0 : _.customDataTypes;
        typeof R == "string" && (R = K(R)), t.push({
          command: "setCustomDataTypes",
          data: R
        });
      }
      (h = e.additionalSettings) != null && h.allowUnknownCardTypes && t.push({ command: "enableUnknownCardTypes" }), (o = e.additionalSettings) != null && o.enablePrettyFormat && t.push({ command: "enablePrettyFormat" }), e.initialSettings.cvv && (t.push({
        command: "setCardType",
        data: (p = e.additionalSettings) == null ? void 0 : p.cardType
      }), e.initialSettings.cvvOnly ? (m = e.additionalSettings) != null && m.cvvPlaceholder && t.push({
        command: "setPlaceholder",
        data: (s = e.additionalSettings) == null ? void 0 : s.cvvPlaceholder
      }) : ((y = e.additionalSettings) != null && y.cvvPlaceholder && t.push({
        command: "setCvvPlaceholder",
        data: e.additionalSettings.cvvPlaceholder
      }), ((l = e.additionalSettings) != null && l.cvvInputType || (v = e.additionalSettings) != null && v.maskInput) && t.push({
        command: "setCvvType",
        data: e.additionalSettings.maskInput ? "password" : ((I = e.additionalSettings) == null ? void 0 : I.cvvInputType) ?? "text"
      }))), !e.initialSettings.cvvOnly && ((n = e.additionalSettings) != null && n.forterSiteId) && ((a = e.additionalSettings) != null && a.forterUsername) && t.push({
        command: "enableForterIntegration",
        data: {
          forterSiteId: e.additionalSettings.forterSiteId,
          forterUsername: e.additionalSettings.forterUsername
        }
      });
    }
    !e.initialSettings.pci && !x(((d = e.additionalSettings) == null ? void 0 : d.customRegEx) ?? "") && t.push({
      command: "setCustomRegEx",
      data: (g = e.additionalSettings) == null ? void 0 : g.customRegEx
    }), (T = e.additionalSettings) != null && T.enableAutoComplete && t.push({ command: "enableAutoComplete" }), (C = e.additionalSettings) != null && C.enableValidateOnBlur && t.push({ command: "enableValidateOnBlur" }), (w = e.additionalSettings) != null && w.enableAriaRequired && t.push({ command: "enableAriaRequired" }), (E = e.additionalSettings) != null && E.debug && t.push({ command: "enableDebug" }), (k = e.additionalSettings) != null && k.font && t.push({
      command: "setFont",
      data: e.additionalSettings.font
    }), (B = e.additionalSettings) != null && B.enableValidateOnKeyUp && t.push({ command: "enableValidateOnKeyUp" }), (P = e.additionalSettings) != null && P.enableValidateOnCvvKeyUp && t.push({ command: "enableValidateOnCvvKeyUp" }), (V = e.additionalSettings) != null && V.inputMode && t.push({
      command: "setInputMode",
      data: e.additionalSettings.inputMode
    }), e.initialSettings.useKount && Ot(), t.forEach(
      ({ command: R, data: W }) => A(R, W)
    ), U({ type: "InitializationComplete", initialMessages: t });
  }), L("tokenize", (t) => {
    if (e.initialSettings.use3DS) {
      if (!kt(
        t.threeDSecureResponse[0].threeDSMethodURL,
        t.threeDSecureResponse[0].threeDSServerTransID,
        t.threeDSecureResponse[0].threeDSMethodNotificationUrl,
        t.referenceNumber ?? ""
      )) {
        D("3DS Device Fingerprinting", { success: !1 }), U({ type: "3DS Device Fingerprinting", success: !1 });
        return;
      }
      D("3DS Device Fingerprinting", { success: !0 }), U({ type: "3DS Device Fingerprinting", success: !0 });
    }
  }), L(
    "kountDataCollectionEnd",
    (t) => {
      if (t && !x(t.MercSessId)) {
        U({ type: "Kount Data Collection Finished.", success: !0 }), A("kountDataCollectionEnd", t);
        return;
      }
      U({ type: "Kount Data Collection Failed.", success: !1 });
    }
  );
};
Nt();
const Ut = {
  configure: gt,
  validateConfig: ct,
  onEvent: L,
  load: At,
  remove: Bt,
  setFraudServicesRequestDetails: Pt,
  tokenize: () => A("tokenize"),
  validate: () => A("validate"),
  reset: () => A("reset"),
  blur: () => A("blur"),
  cvvBlur: () => A("cvvBlur"),
  focus: () => A("focus"),
  cvvFocus: () => A("cvvFocus"),
  toggleMask: () => A("toggleMask"),
  toggleCvvMask: () => A("toggleCvvMask"),
  binLookup: () => A("binLookup"),
  sendCommandToIframe: (t, i) => A(t, i)
};
export {
  Ut as TokenizeIframe
};
